/**
 * Z-INDEX Hierarchy for the project.
 */
export const levels = {
  behind: -1,
  base: 1,
  highlight: 2,
  prompt: 3,
  persistent: 4,
};
